<template>
  <v-main style="background-color: #b0bec5;" >
    <v-container fluid class="pa-0 d-flex" style="max-width: 400px; height: 100%;">
      <vue-headful title="Meine Leistungen" description="Aimz"/>
        <div class="d-flex pa-0" style="width: 100%; position: relative;">
<!--          <v-img :src="require('@/assets/olympic-medal.jpg')" eager  width="400" style="position: absolute; bottom: 0px; left: 0px;"></v-img>-->
          <v-col class="mt-3 d-flex align-stretch pa-0 flex-column">
<!--            <span class="my-5 white&#45;&#45;text d-flex display-1">Meine Leistungen</span>-->
            <v-card class="mx-3 mb-3 dunkelblau" style="position: relative;">
              <v-img :src="require('@/assets/olympic-medal.jpg')" eager height="150" position="top -50px left" style="opacity: 0.3;">
              </v-img>
              <header1 class="white--text mt-4" style="position: absolute; top:0; ">Meine Leistungen</header1>
            </v-card>
            <leistungen-switcher v-model="subContentIndex"></leistungen-switcher>
            <medaillen v-if="subContentIndex==0"/>
            <index-entwicklung v-else-if="subContentIndex==1"/>
            <challenges v-else-if="subContentIndex==2"/>
<!--            <div class="d-flex">-->
<!--              <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/CE1TP_trDuE" target="_blank">-->
<!--                <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung-->
<!--              </v-btn>-->
<!--            </div>-->
          </v-col>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import UserData from "@/views/UserData";
import CenterContainer from "@/components/CenterContainer";
import Activities from "@/components/Activities";
import InitializeUser from "@/views/InitializeUser";
import Dashboard from "@/components/Dashboard";
import UserLib from "@/components/UserLib";
import Header1 from "@/components/Header1";
import Kinds from "@/components/Kinds";
import Medal from "@/components/Medal";
import LeistungenSwitcher from "@/components/LeistungenSwitcher";
import Medaillen from "@/components/Medaillen";
import IndexEntwicklung from "@/components/IndexEntwicklung";
import Challenges from "@/components/Challenges";
import Challenge from "@/components/Challenge";


const {DateTime} = require("luxon");

const ALL = "Alle";
const THIS_YEAR = "Dieses Jahr";
const LAST_YEAR = "Letztes Jahr";
const THIS_QUARTER = "Dieses Quartal";
const LAST_QUARTER = "Letztes Quartal";
const THIS_MONTH = "Dieses Monat";
const LAST_MONTH = "Letztes Monat";

export default {
  name: 'Leistungen',
  components: {IndexEntwicklung, Medaillen, LeistungenSwitcher, Medal, CenterContainer, Header1, Challenges },
  data: () => ({
    medals:[],
    loading:false,
    epochs: [ALL, THIS_YEAR, LAST_YEAR, THIS_QUARTER, LAST_QUARTER, THIS_MONTH, LAST_MONTH],
    epoch: ALL,
    subContentIndex: 0,
  }),
  mounted() {
    if (!this.$app.is_logged_in) {
      this.$store.commit("set", {key: "intern", value: false});
      if (this.$route.path != "/")
        this.$router.replace("/");
      return;
    }
    this.$store.commit("set", {key: "intern", value: true});
    this.load();
  },
  methods: {
    async load(){
      this.loading=true;
      //var id = Badge.makeId(this.weekDate.toISODate(), "index");
      var badges=(await this.$backend.get_all_objects(Kinds.KIND_BADGE)) || [];
      console.log("Badges: ", badges);
      this.medals=badges;
      this.loading=false;
    },
    medalsOfEpoch() {
      var date = DateTime.local();
      var year=date.toISODate().substring(0,4);
      var lastYear = date.minus({years:1}).toISODate().substring(0,4);
      switch (this.epoch)
      {
        case THIS_YEAR:
          return this.medals.filter(x=>x.date.startsWith(year));
        case LAST_YEAR:
          return this.medals.filter(x=>x.date.startsWith(lastYear));
        case THIS_QUARTER:
          var month=new Date(Date.now()).getMonth();
          var q=Math.floor(month / 3)+1;
          console.log("filtering THIS_QUARTER " + q);
          switch (q) {
            case 1: return this.medals.filter(x => x.date.startsWith(year + "-01") || x.date.startsWith(year + "-02") || x.date.startsWith(year + "-03"));
            case 2: return this.medals.filter(x => x.date.startsWith(year + "-04") || x.date.startsWith(year + "-05") || x.date.startsWith(year + "-06"));
            case 3: return this.medals.filter(x => x.date.startsWith(year + "-07") || x.date.startsWith(year + "-08") || x.date.startsWith(year + "-09"));
            case 4: return this.medals.filter(x => x.date.startsWith(year + "-10") || x.date.startsWith(year + "-11") || x.date.startsWith(year + "-12"));
          }
          break;
        case LAST_QUARTER:
          var month=new Date(Date.now()).getMonth();
          var q=Math.floor(month / 3)+0; // <-- last quarter!
          console.log("filtering LAST_QUARTER " + q);
          switch (q) {
            case 0: return this.medals.filter(x => x.date.startsWith(lastYear + "-10") || x.date.startsWith(lastYear + "-11") || x.date.startsWith(lastYear + "-12"));
            case 1: return this.medals.filter(x => x.date.startsWith(year + "-01") || x.date.startsWith(year + "-02") || x.date.startsWith(year + "-03"));
            case 2: return this.medals.filter(x => x.date.startsWith(year + "-04") || x.date.startsWith(year + "-05") || x.date.startsWith(year + "-06"));
            case 3: return this.medals.filter(x => x.date.startsWith(year + "-07") || x.date.startsWith(year + "-08") || x.date.startsWith(year + "-09"));
          }
          break;
        case THIS_MONTH:
          var mon=date.toISODate().substring(0,7);
          console.log("filtering THIS_MONTH " + mon);
          return this.medals.filter(x => x.date.startsWith(mon));
        case LAST_MONTH:
          var mon=date.minus({months:1}).toISODate().substring(0,7);
          console.log("filtering LAST_MONTH " + mon);
          return this.medals.filter(x => x.date.startsWith(mon));
      }
      return this.medals;
    },
    numbers(type){
      var medalsOfType=[... this.medalsOfEpoch().filter(x=>x.type===type)];
      return [
        // note: diamond is for backwards compatibility, the back-end granted diamonds until 2021-08-11 !!
        {value:'gold', num:medalsOfType.filter(x=> x.value==='gold'||x.value==='diamond').length},
        {value:'silver', num:medalsOfType.filter(x=> x.value==='silver').length},
        {value:'bronze', num:medalsOfType.filter(x=> x.value==='bronze').length},
      ];
    },
    onHelpWochengesamtwertung() {
      this.$events.$emit("ask", {
        title: 'Medaillen', yes_button: 'OK',
        question: 'Medaillen kannst du jede Woche gewinnen, wenn du deine Ziele erreichst. Für 75% gibt es Bronze, für 90% Silber und ab 100% Gold.<br>' +
            'Sie sollen dich anspornen die gesteckten Ziele auch wirklich zu erreichen<br><br>' +
            'Die großen Medaillen werden nach dem Wochenindex vergeben, die kleinen nach dem Bereichsindex. Da der Wochenindex aus den gewichteten Bereichsindizes gemittelt wird, ' +
            'ist die Anzahl der großen Medaillen immer weniger als die Summe der Bereichsmedaillen.',
      });
    },
  },
  computed: {
    app() {
      return this.$app;
    },
    numMedals() {
      return this.medals.length;
    },
    indexMedals() {
      return this.medals.filter(x=>x.type==='index');
    },
    bereiche() {
      return this.$app.bereiche;
    }
  },
  watch: {
    // is_logged_in(n, o) {
    //     console.log("is_logged_in: " + n);
    //     if (!n) {
    //         this.$router.go(-1000);
    //         this.$router.replace("/")
    //     }
    // }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>